import { Dispatch } from 'react';
import { UnknownAction } from '@reduxjs/toolkit';

import { InitialMapViewState, ViewStateChangeParameters } from '@methanesat/maps';
import { playwrightAddViweport } from '../../../test/e2e/utils';
import { ENVIRONMENT } from '../../environmentVariables';
import { setEmissionsMapViewState } from '../../reducers';
import { ViewStatePropsQueryString } from '../../types';

// handler for viewStateChange event on Deck
export function onViewStateChangeHelper({
    viewState,
    dispatch,
    throttledUpdateBBox
}: {
    viewState: ViewStateChangeParameters['viewState'];
    dispatch: Dispatch<UnknownAction>;
    throttledUpdateBBox: (viewState: InitialMapViewState) => void;
}) {
    // this allows us to exclude non-serializable properties
    // of viewState from the store (ex. transitionEasing )
    const { latitude, longitude, zoom, bearing, pitch, altitude, height, width } = viewState;

    // We remove any undefineds so the Google base map is able to send a partial
    // viewState update without affecting other values
    const newViewState = Object.entries({
        latitude,
        longitude,
        zoom,
        bearing,
        pitch,
        altitude,
        height,
        width
    }).reduce((createdViewState, [key, value]) => {
        if (value !== undefined) {
            return { ...createdViewState, [key]: value };
        }
        return createdViewState;
    }, {});
    dispatch(setEmissionsMapViewState(newViewState as ViewStatePropsQueryString));

    // adding Viewport to window for playwright e2e tests
    if (ENVIRONMENT !== 'production') {
        playwrightAddViweport(viewState);
    }

    throttledUpdateBBox(viewState as InitialMapViewState);
}
